// Context
import { LegacyContext } from './context/global-context';

export const IntegrationsContextProvider = LegacyContext.Provider;

// Types
export type { Settings as SlackSettings } from './hooks/use-slack-state';

export type {
  Settings as MsTeamsSettings,
  FeedbackSettings as MsTeamsFeedbackSettings,
  SurveySettings as MsTeamsSurveySettings,
} from './domains/ms-teams/api';

export type {
  WidgetId,
  WidgetType,
  Configuration as WidgetConfigurationType,
} from './domains/slack/api/widget-configuration';

export type { IntegrationToken, OauthToken, OtterIntegrationStatus } from './domains/api';

// Components
export { IntegrationsPage } from './IntegrationsPage';

export { IntegrationDetailsPage } from './IntegrationDetailsPage';

export { EnableSlackModal } from './components/EnableSlackModal';

export { EnableMsTeamsModal } from './components/MsTeamsModals/EnableMsTeamsModal';

export { HubspotOAuth } from './components/IntegrationActions/HubspotOAuth';

// Hooks
export { useIntegrationTokens } from './hooks/use-integrations-tokens';

export { useEnabledIntegrationNames } from './hooks/use-enabled-integration-names';

export { useSlackForwardingSettings } from './hooks/use-slack-forwarding-settings';

export { useOtterIntegration } from './hooks/use-otter-integration';

export { useMsTeamsForwardingSettings } from './hooks/use-ms-teams-forwarding-settings';

export { useWebhooksForwardingSettings } from './hooks/use-webhooks-forwarding-settings';

export { useSlackState } from './hooks/use-slack-state';

// Domains
export { IntegrationTokenName } from './domains/api';

export { sendWebhookTestMessage as sendMsTeamsWebhookTestMessage } from './domains/ms-teams/api';

export { sendWebhookTestMessage } from './domains/webhooks/api';

export * as SlackApi from './domains/slack/api';

export * as WidgetConfiguration from './domains/slack/api/widget-configuration';

export * as SlackFeature from './domains/slack/feature';

export * as MsTeamsFeature from './domains/ms-teams/feature';

export * as WebhooksFeature from './domains/webhooks/feature';

export * as ZapierFeature from './domains/zapier/feature';

export { ACTION_NAME as SLACK_CONNECT_ACTION_NAME } from './domains/slack/connect';
